import * as moment from 'moment'
import * as React from 'react'
import { Link, Route, RouteComponentProps } from 'react-router-dom'
import { IRefundTransactionDTO, IWalletTransactionResponseDTO } from '../../../../types'
import { priceValueMask } from '../../../../utils/mask'
import UIMessages from 'src/utils/ui-messages'
import history from '../../../../history'
import RechargeWalletButton from './RechargeWalletButton'
import { topUpDetails } from 'src/utils'
import { Button } from '@mobiscroll/react-latest'

interface IWalletTransactionItemProps {
  transaction: IWalletTransactionResponseDTO
  timeFormat: string
  currentUserId: string
  riderId: string
  path: string
  assignRefundDetails: (params: IRefundTransactionDTO) => void
  isRechargeAllowed: boolean
}

class WalletTransactionItem extends React.Component<IWalletTransactionItemProps, any> {
  constructor(props: any) {
    super(props)
  }

  public render() {
    const { transaction } = this.props
    const transactionId = transaction.stripeTransactionId || 'N/A'
    const tripId =
      (transaction.rideId !== null && transaction.rideId.substring(0, Math.min(transaction.rideId.length, 6))) || 'N/A'

    const { netAmount, totalFee } = topUpDetails(transaction.amount, transaction.transactionFee)

    const formattedNetAmount = (transactionType: string) => {
      if (transactionType !== 'CR') {
        return ''
      }

      return totalFee === 0 ? 'N/A' : `+${priceValueMask(netAmount)}`
    }

    const formattedTotalFee = (transactionType: string) => {
      if (transactionType !== 'CR') {
        return ''
      }

      return totalFee === 0 ? 'N/A' : priceValueMask(totalFee)
    }

    const capitalize = (s: string) => (s && String(s[0]).toUpperCase() + String(s).slice(1)) || ''

    return (
      <>
        <span className='flex items-center'>
          <div className='col-2'>
            <span className='h5 font-grey2'>{moment(transaction.createdAt).format('MM.DD.YY HH:mm A')}</span>
          </div>
          <div className='col-4'>
            <span className='TransactionId h5 font-grey2'>{transactionId}</span>
          </div>
          <div className='col-1'>
            {transaction.rideId ? (
              <Link to={`/trips/${transaction.rideId}`}>
                <span className='TransactionId h5 font-blue underline'>{tripId}</span>
              </Link>
            ) : (
              <span className='TransactionId h5 font-grey2'>{tripId}</span>
            )}
          </div>
          <div className='col-1'>
            <span className='TransactionType h5 font-grey2'>{capitalize(transaction.transactionType)}</span>
          </div>
          <div className='col-2'>
            <span className='h5 font-grey2'>{capitalize(transaction.paymentMethod)}</span>
          </div>
          <div className='col-1-5'>
            <span className={`h5 ${transaction.transactionType === 'CR' ? 'font-green' : 'font-grey2'}`}>
              {formattedNetAmount(transaction.transactionType)}
            </span>
          </div>
          <div className='col-1-5'>
            <span className={`h5 font-grey2`}>
              {(transaction.transactionType === 'CR' ? '+' : '-') + priceValueMask(transaction.amount / 100)}
            </span>
          </div>
          <div className='col-1-5'>
            <span className='h5 font-grey2'>{formattedTotalFee(transaction.transactionType)}</span>
          </div>

          {this.props.isRechargeAllowed && <RechargeWalletButton {...transaction} />}
          <div className='col-1-5'>
            {transaction.refundable === true && transaction.transactionType === 'CR' ? (
              <Button className='mbsc-green-btn mbsc-btn-sm' ariaLabel='refund' onClick={() => this.refundPayment()}>
                {UIMessages.common.refund}
              </Button>
            ) : (
              transaction.transactionType === 'CR' && <div />
            )}
          </div>
          <div className='col-1-5'>
            <span className='h5 font-grey2'>{priceValueMask(transaction.totalBalance / 100)}</span>
          </div>
          <div className='col-3'>
            <span className='h5 font-grey2'>{transaction.transactionMessage}</span>
          </div>
          <div className='col-2'>
            <span className='h5 font-grey2'>
              {transaction.initiatorUser
                ? `${transaction.initiatorUser.firstName} ${transaction.initiatorUser.lastName}`
                : ''}
            </span>
          </div>
        </span>
      </>
    )
  }

  private refundPayment() {
    const { transaction, assignRefundDetails } = this.props
    if (transaction.transactionType === 'CR') {
      assignRefundDetails({
        stripeSourceId: transaction.stripeSourceId,
        stripeTransactionId: transaction.stripeTransactionId,
        walletId: transaction.walletId,
        amount: transaction.amount,
        currentUserId: this.props.currentUserId,
        riderId: this.props.riderId
      })
      history.push(`${this.props.path}/refund-transaction`)
    } else {
      alert('transaction is non refundable')
    }
  }
}

export default WalletTransactionItem



// WEBPACK FOOTER //
// ./src/components/riders/riderdetails/wallet/WalletTransactionListItem.tsx